module.exports = __webpack_public_path__ + "static/media/warning_referral.27db3711.svg";